import { Box, Typography } from '@mui/material'
import { NoResult2 } from '@workwave-tidal/core/icons/illustrations'

import { useTexts } from '../hooks/useTexts'

import { CardContainer } from './CardContainer'

export function NoAssetsCard() {
  const texts = useTexts()

  return (
    <CardContainer>
      <Box pb={1}>
        <NoResult2 size={48} />
      </Box>

      <Typography variant="subtitle4">{texts.card.noAssets.title}</Typography>
      <Typography variant="caption">{texts.card.noAssets.subtitle}</Typography>
    </CardContainer>
  )
}
